import { forwardRef, InputHTMLAttributes } from 'react'
import cn from 'classnames'
import { Icon } from '@/icons'

import styles from './Checkbox.module.scss'

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string
  error?: string
  label?: string
}
type CheckboxRef = HTMLInputElement
export const Checkbox = forwardRef<CheckboxRef, CheckboxProps>(
  ({ className, label, error, children, ...props }, ref) => {
    return (
      <div>
        <label className={cn(styles.row, className)}>
          <span className={styles.iconContainer}>
            <input
              type="checkbox"
              className={styles.input}
              ref={ref}
              {...props}
            />
            <span
              className={cn(styles.mark, {
                [styles.isError]: error != null && error.length !== 0,
              })}
            >
              <Icon name="check" className={styles.markIcon} />
            </span>
          </span>

          <span className={styles.label}>{label ? label : children}</span>
        </label>
        {error != null && error.length !== 0 ? (
          <div className={styles.error}>
            <Icon name="alert" className={styles.iconError} />
            {error}
          </div>
        ) : null}
      </div>
    )
  }
)
Checkbox.displayName = 'Checkbox'
